import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestService } from 'src/app/services/request.service';
import { TranslateService } from '@ngx-translate/core';
import { ShareDataService } from 'src/app/services/share-data.service';
import { forkJoin, map, of } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-trap',
  templateUrl: './add-trap.component.html',
  styleUrls: ['./add-trap.component.scss']
})
export class AddTrapComponent implements OnInit {

  availablePlots: any[] = [];
  plotCode: any = '';
  editPlotCode: any = '';
  plotCodes: any = [];
  date: any = '';
  operator: any = '';
  traps: any[] = [];
  type: any = '';
  types: any = [
    'DACUS.FOOD',
    'DACUS.PHEROMONE',
    'DACUS.CHROMATIC',
  ];
  action: any = [];
  actions: any = [
    'DACUS.ACTION_1',
    'DACUS.ACTION_2',
    'DACUS.ACTION_3',
  ];
  relatedActions: any = [
    '31.6.Β',
    '31.6.Γ',
    '31.6.Δ',
    '31.6.Ε',
    '31.6.ΣΤ',
    '31.6.Ζ',
    '31.6.Η',
    '31.6.θ',
    '31.6.ΙΓ',
  ];
  relatedAction: any = '';
  insectTypes: any = [
    // "Αγροτίδα",
    // "Αλευρώδεις",
    // "Ανάρσια",
    // "Ανθονόμος",
    // "Ανθοτρήτης",
    // "Αρίων ο ερυθρός ή μεγάλος κόκκινος",
    // "Αρίων ο κηπαίος",
    // "Ασπρη ψώρα",
    // "Αφίδες",
    // "Βαμβακάδα (Ψευδόκοκκος)",
    // "Βαμβακάδα Εληάς",
    // "Βαμβακάδα ή Διάσπις",
    // "Βρωμούσα (Καλόκορις)",
    "Δάκος της Ελιάς",
    // "Ελιξ ή κοχλίας ο ποματίας",
    // "Εριόσωμα",
    // "Ερπουσα ψώρα",
    // "Ευδεμίδα",
    // "Ζεύζερα",
    // "Θρίπες",
    // "Ισέρυα",
    // "Καρπόκαψα",
    // "Καφέ βρωμούσα",
    // "Κηροπλάστης",
    // "Κίτρινος τετράνυχος",
    // "Κόκκινη ψώρα",
    // "Κόκκινο ακάρι",
    // "Κοκκοειδή",
    // "Κόσσος",
    // "Κοχυλίδα",
    // "Λείμαξ ο αγροδίαιτος",
    // "Λεκάνιο",
    // "Λεπιδόπτερα",
    // "Μαλακόσωμα",
    // "Μαργαρόνια",
    // "Ματόψειρα",
    // "Μαύρη ψώρα",
    // "Μηλολόνθη",
    // "Μύγα της Ασίας",
    // "Μύγα της Μεσογείου",
    // "Μυτιλόμορφη ψώρα",
    // "Νάρκη",
    // "Οπλοκάμπη",
    // "Οτιόρυγχος",
    // "Παραμορφωτικό άκαρι",
    // "Παρλατόρια",
    // "Πολλίνια",
    // "Πράσινη αφίδα",
    // "Πυραλίδα",
    // "Πυρηνοτρήτη",
    // "Ραγολέτιδα",
    // "Ρυγχίτης Εληάς",
    // "Σποντόπτερα",
    // "Τετράνυχοι",
    // "Τζιτζικάκια",
    // "Τυλιγάδι",
    // "Υπονομευτές",
    // "Υφάντρια",
    // "Φυλλοδέτες",
    // "Φυλλοδέτες",
    // "Φυλλοκνίστης",
    // "Φυλλορύκτες",
    // "Φυλλοφάγες προνύμφες",
    // "Φυτόπτες",
    // "Ψευδόκοκκος",
    // "Ψύλλα",
    // "Ψύλλα αχλαδιάς",
    // "Ψύλλα της αχλαδιάς",
    // "Ψώρα του San Jose"
  ];

  insectType: any = ''
  constructor(private cdr: ChangeDetectorRef, private req: RequestService<any>, private shareDataService: ShareDataService, private translate: TranslateService,
    public dialogRef: MatDialogRef<AddTrapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.shareDataService.getData<any>('plots').subscribe((res: any) => {
      if (res) {
        this.availablePlots = res;
        this.availablePlots.forEach((element: any) => {
          this.plotCodes.push([element.plot_code, element.location, element._id]);

          if (this.data) {
            this.date = this.data.placement_date;
            this.operator = this.data.placed_by;
            this.editPlotCode = `${this.data.plotCode} - ${this.data.location}`;
            this.plotCode = this.data.plot_id;

            this.traps = [{
              name: this.data.trap_num,
              lat: this.data.coordinates[0].lat,
              lon: this.data.coordinates[0].lon,
              type: this.data.trap_type,
              relatedAction: this.data.related_action,
              measurements: this.data.measurements.map((measurement: any) => {
                return {
                  action: measurement.action ? [...measurement.action] : [],
                  insectType: this.data.enemy_type ?? '',
                  totalFlies: measurement.fly_total ?? null,
                  totalMales: measurement.fly_male ?? null,
                  totalFemales: measurement.fly_female ?? null,
                  diseaseCount: measurement.disease_count ?? null,
                  larva: measurement.mean_larval ?? null,
                  comments: measurement.comments ?? '',
                  measurementDate: measurement.measurement_date || ''
                };
              }),
              editActions: false
            }];
          } else {
            this.traps = [];
            this.addTrap();
          }
        });
      }
    });
  }

  translatedActions(measurement: any): string[] {
    if (!measurement?.action) return [];
    return measurement.action.map((action: string) => this.translate.instant(action));
  }

  enableEdit(measurement: any) {
    measurement.editActions = true;
  }

  disableEdit(measurement: any) {
    measurement.editActions = false;
  }

  addTrap(): void {
    const newTrap = {
      name: '',
      lat: '',
      lon: '',
      type: '',
      relatedAction: '',
      action: [],
      insectType: '',
      totalFlies: null,
      totalMales: null,
      totalFemales: null,
      diseaseCount: null,
      larva: null,
      comments: '',
      measurementDate: '',
      measurements: []
    };
    this.traps.push(newTrap);
  }

  removeTrap(index: number): void {
    if (this.traps.length > 1) {
      this.traps.splice(index, 1);
    }
  }

  addMeasurement(trapIndex: number): void {
    const newMeasurement = {
      action: [],
      insectType: '',
      totalFlies: null,
      totalMales: null,
      totalFemales: null,
      diseaseCount: null,
      larva: null,
      comments: '',
      measurementDate: '',
      editActions: false
    };
  
    this.traps[trapIndex].measurements.push(newMeasurement);
  }

  removeMeasurement(trapIndex: number, measurementIndex: number): void {
    if (this.traps[trapIndex].measurements.length > 1) {
      this.traps[trapIndex].measurements.splice(measurementIndex, 1);
    }
  }

  isExistingMeasurement(measurement: any): boolean {
    return !!measurement.measurementDate;
  }

  isDeleteDisabled(): boolean {
    return this.traps.length <= 1;
  }

  saveOrUpdateTrap(): void {
    const currentLang = this.translate.currentLang;
    this.translate.use('gr').subscribe(() => {
      const translationObservables = this.traps.map((trap) => {
        const translatedType$ = this.translate.get(trap.type);
        const actionTranslations$ = trap.action?.length
          ? forkJoin(trap.action.map((action: string) => this.translate.get(action)))
          : of([]);
  
        if (trap.measurements.length === 0) {
          const cleanedMeasurement = {
            action: trap.action ? [...trap.action] : [],
            enemy_type: trap.insectType ?? '',
            comments: trap.comments ?? '',
            disease_count: trap.diseaseCount ?? 0,
            fly_female: trap.totalFemales ?? 0,
            fly_male: trap.totalMales ?? 0,
            fly_total: trap.totalFlies ?? 0,
            mean_larval: trap.larva ?? 0,
            measurement_date: trap.measurementDate ?? '',
          };
  
          const actionTranslationsForMeasurement$ = trap.action?.length
            ? forkJoin(trap.action.map((action: string) => this.translate.get(action)))
            : of([]);
  
          return forkJoin({
            translatedType: translatedType$,
            translatedActions: actionTranslations$,
            translatedMeasurements: forkJoin([forkJoin({
              translatedActions: actionTranslationsForMeasurement$,
            }).pipe(
              map(({ translatedActions }) => ({
                ...cleanedMeasurement,
                action: translatedActions ? translatedActions : [],
              }))
            )]),
          }).pipe(
            map(({ translatedType, translatedActions, translatedMeasurements }) => ({
              trap_num: trap.name || null,
              trap_type: translatedType || '',
              related_action: trap.relatedAction || '',
              coordinates: [{
                kombos: '1',
                lat: trap.lat || 0,
                lon: trap.lon || 0,
              }],
              placed_by: this.operator || '',
              placement_date: this.date || '',
              measurements: translatedMeasurements,
            }))
          );
        }
  
        // Handle the case where there are measurements (edit case)
        const measurementTranslations$ = trap.measurements.map((measurement: any) => {
          const cleanedMeasurement = {
            action: measurement.action ? [...measurement.action] : [],
            enemy_type: measurement.insectType ?? '',
            comments: measurement.comments ?? '',
            disease_count: measurement.diseaseCount ?? 0,
            fly_female: measurement.totalFemales ?? 0,
            fly_male: measurement.totalMales ?? 0,
            fly_total: measurement.totalFlies ?? 0,
            mean_larval: measurement.larva ?? 0,
            measurement_date: measurement.measurementDate ?? '',
          };
  
          const actionTranslationsForMeasurement$ = measurement.action?.length
            ? forkJoin(measurement.action.map((action: string) => this.translate.get(action)))
            : of([]);
  
          return forkJoin({
            translatedActions: actionTranslationsForMeasurement$,
          }).pipe(
            map(({ translatedActions }) => ({
              ...cleanedMeasurement,
              action: translatedActions ? translatedActions : [],
            }))
          );
        });
  
        return forkJoin({
          translatedType: translatedType$,
          translatedActions: actionTranslations$,
          translatedMeasurements: forkJoin(measurementTranslations$),
        }).pipe(
          map(({ translatedType, translatedActions, translatedMeasurements }) => ({
            trap_num: trap.name || null,
            trap_type: translatedType || '',
            related_action: trap.relatedAction || '',
            coordinates: [{
              kombos: '1',
              lat: trap.lat || 0,
              lon: trap.lon || 0,
            }],
            placed_by: this.operator || '',
            placement_date: this.date || '',
            measurements: translatedMeasurements,
          }))
        );
      });
  
      forkJoin(translationObservables).subscribe({
        next: (translatedTraps) => {
          const updatedData = {
            _id: this.data?._id || undefined,
            plot_id: this.data?.plot_id ? this.data.plot_id : this.plotCode[2],
            traps: translatedTraps
          };
  
          this.translate.use(currentLang).subscribe(() => {
            if (this.data) {
              this.updateTrap(this.data.id, updatedData);
            } else {
              this.req.postTrap(updatedData).subscribe({
                next: () => {
                  this.translate.get(["DACUS.TITLE_ADD", "DACUS.TEXT_ADD"]).subscribe(translations => {
                    Swal.fire({
                      title: translations["DACUS.TITLE_ADD"],
                      text: translations["DACUS.TEXT_ADD"],
                      icon: 'success',
                      timer: 3000,
                    });
                  });
                  this.dialogRef.close();
                },
              });
            }
          });
        }
      });
    });
  }

  updateTrap(id: any, updatedData: any): void {
    this.req.updateTrap(id, updatedData).subscribe({
      next: () => {
        const title = "DACUS.TITLE_UPDATE";
        const text = "DACUS.TEXT_UPDATE";
        this.translate.get([title, text])
          .subscribe(translations => {
            Swal.fire({
              title: translations[title],
              text: translations[text],
              icon: 'success',
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              },
              timer: 3000,
            });
          })
        this.dialogRef.close();
      },
    });
  }
}